import script from "./TabItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabItem.vue?vue&type=script&setup=true&lang=ts"

import "./TabItem.vue?vue&type=style&index=0&id=26d2ffac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d2ffac"]])

export default __exports__